import React, { useEffect, useState } from 'react';
import CantDeleteFieldDialogView from '../view/CantDeleteFieldDialogView';

const CantDeleteFieldEngine = ({
  allFields = [],
  fieldIdThatCantBeDeleted,
  showCantDeleteFieldDialog,
  setShowCantDeleteFieldDialog,
  dependencyData,
  clickedDeleteAnyway
}) => {
  const hasCurrentFormDependencies =
    dependencyData?.hasScoringDependencies ||
    dependencyData?.hasVisibilityDependencies ||
    dependencyData?.hasAutomationDependencies ||
    dependencyData?.hasReminderDependencies;

  const hasScoringDependencies = dependencyData?.hasScoringDependencies > 0;

  let originalExpandedAccordion = false;
  const dependencyFieldIds = dependencyData?.dependenciesByField
    ? Object.keys(dependencyData.dependenciesByField)
    : [];
  if (hasCurrentFormDependencies) {
    originalExpandedAccordion = 'current-form-' + fieldIdThatCantBeDeleted;
  } else if (dependencyData?.hasLookupDependencies) {
    let firstDependencyFieldId = dependencyFieldIds[0];
    let lookupDependencies =
      dependencyData.dependenciesByField[firstDependencyFieldId]
        ?.lookupDependencies || [];
    if (lookupDependencies.length > 0) {
      originalExpandedAccordion = lookupDependencies[0].formId || false;
    }
  }
  const [expandedAccordion, setExpandedAccordion] = useState(
    originalExpandedAccordion
  );

  useEffect(() => {
    if (!showCantDeleteFieldDialog || !fieldIdThatCantBeDeleted) {
      return;
    }
    setExpandedAccordion(originalExpandedAccordion);
  }, [fieldIdThatCantBeDeleted, allFields, showCantDeleteFieldDialog]);

  const handleAccordionClick = panel => (event, isExpanded) => {
    setExpandedAccordion(isExpanded ? panel : false);
  };

  const isSection = dependencyData.isTryingToDeleteSection;

  const sectionFieldIndices = isSection ? Object.keys(dependencyData) : [];
  let sectionFieldTitles = {};
  sectionFieldIndices.forEach(one => {
    const sectionField = allFields.find(
      matchingField => matchingField.id === one
    );
    sectionFieldTitles[one] = sectionField?.title || 'Untitled field';
  });

  const viewProps = {
    allFields,
    clickedDeleteAnyway,
    showCantDeleteFieldDialog,
    setShowCantDeleteFieldDialog,
    hasCurrentFormDependencies,
    expandedAccordion,
    handleAccordionClick,
    hasScoringDependencies,
    dependencyData,
    dependencyFieldIds,
    sectionFieldIndices,
    sectionFieldTitles,
    isSection
  };

  return <CantDeleteFieldDialogView {...viewProps} />;
};

export default CantDeleteFieldEngine;
